const search = document.querySelector('#search');

if (search) {
  let page = 1;
  let request = 0;
  const hero = document.querySelector('.search-hero');
  const spinner = document.querySelector('.search-hero__spinner');
  const results = document.querySelector('.search-results__found');
  const noResults = document.querySelector('.search-results__none');
  const total = document.querySelector('.search-results__total');
  const list = document.querySelector('.search-results__list');
  const loadMore = document.querySelector('.search-results__load-more');
  const query = new URLSearchParams(location.search);
  const keywords = query.get('keywords');

  if (!search.value && keywords) {
    search.value = keywords;
    doSearch();
    emit();
  }

  let delay;
  let emitDelay;

  search.addEventListener('input', () => {
    if (delay) {
      clearTimeout(delay);
      delay = null;
    }

    if (emitDelay) {
      clearTimeout(emitDelay);
      emitDelay = null;
    }

    if (search.value) {
      hero.classList.add('search-hero--small');
    } else {
      hero.classList.remove('search-hero--small');
    }

    delay = setTimeout(onSearch, 500);
  });

  function onSearch() {
    delay = null;
    emitDelay = setTimeout(emit, 2000);
    history.replaceState(null, null, '?keywords=' + encodeURIComponent(search.value));
    doSearch();
  }

  loadMore.addEventListener('click', () => {
    loadMore.disabled = true;
    doSearch(page + 1, true);
  });

  function doSearch(p = 1, append = false) {
    page = p;
    request++;
    const _request = request;
    spinner.style.display = 'block';

    if (search.value) {
      fetch(`${ajaxurl}?action=search&s=${encodeURIComponent(search.value)}&p=${p}`)
        .then((response) => response.json())
        .then((response) => {
          results.style.display = response.data.total ? null : 'none';
          noResults.style.display = response.data.total ? 'none' : null;
          total.textContent = `${response.data.total} entr${response.data.total > 1 ? 'ies' : 'y'} found`;

          if (append) {
            list.innerHTML += response.data.html;
          } else {
            list.innerHTML = response.data.html;
          }

          if (p * 6 < response.data.total) {
            loadMore.style.display = null;
            loadMore.disabled = false;
          } else {
            loadMore.style.display = 'none';
            loadMore.disabled = true;
          }

          if (_request === request) {
            spinner.style.display = 'none';
          }
        });
    } else {
      results.style.display = 'none';
      noResults.style.display = 'none';
      spinner.style.display = 'none';
    }
  }

  function emit() {
    emitDelay = null;

    if (typeof window.ga === 'function') {
      window.ga('send', 'pageview');
    }
  }
}